import { render, staticRenderFns } from "./SecondReportCategoriesSection.vue?vue&type=template&id=0f803bae&scoped=true&"
import script from "./SecondReportCategoriesSection.vue?vue&type=script&lang=js&"
export * from "./SecondReportCategoriesSection.vue?vue&type=script&lang=js&"
import style0 from "./SecondReportCategoriesSection.vue?vue&type=style&index=0&id=0f803bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f803bae",
  null
  
)

export default component.exports